import script from "./UserCreatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCreatePage.vue?vue&type=script&setup=true&lang=js"

import "./UserCreatePage.vue?vue&type=style&index=0&id=47813ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47813ee0"]])

export default __exports__